var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoamMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6538 5.83721C16.9231 5.83721 17.9615 4.74884 17.9615 3.4186C17.9615 2.08837 16.9231 1 15.6538 1C14.3846 1 13.3462 2.08837 13.3462 3.4186C13.3462 4.74884 14.3846 5.83721 15.6538 5.83721ZM11.3846 9.94884L8.43077 25.5609C8.28077 26.2986 8.83462 27 9.56154 27H9.65385C10.1962 27 10.6577 26.613 10.7846 26.0567L12.6538 17.3256L15.0769 19.7442V25.7907C15.0769 26.4558 15.5962 27 16.2308 27C16.8654 27 17.3846 26.4558 17.3846 25.7907V18.9702C17.3846 18.3051 17.1308 17.6763 16.6692 17.2167L14.9615 15.5116L15.6538 11.8837C16.9541 13.4418 18.7342 14.473 20.6846 14.7981C21.3769 14.907 22 14.3265 22 13.5888C22 12.9963 21.5846 12.5005 21.0192 12.4037C19.2654 12.1014 17.8115 11.013 17.0385 9.58605L15.8846 7.65116C15.573 7.12894 15.0943 6.73997 14.534 6.55385C13.9738 6.36774 13.3687 6.39663 12.8269 6.63535L8.40769 8.59442C7.98967 8.78168 7.63337 9.09358 7.3831 9.49134C7.13282 9.88909 6.9996 10.3552 7 10.8316V13.6977C7 14.3628 7.51923 14.907 8.15385 14.907C8.78846 14.907 9.30769 14.3628 9.30769 13.6977V10.7953L11.3846 9.94884Z",
    fill: "#072983"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoamMan);
export default __webpack_public_path__ + "static/media/roam-man.7e79dec1f9ecf50e6903de11d91170a3.svg";
export { ForwardRef as ReactComponent };